export default "__VITE_ASSET__Va$$omMD__"